import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IOneTablePayload {
    tableId: string
}

export interface IOneTableState {
    status: string
    data: null
    errors: any
}

const initialState: IOneTableState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const oneTable = createSlice({
    name: 'table/one-table',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IOneTablePayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const oneTableActions = oneTable.actions
export default oneTable.reducer
